import { createGlobalStyle } from 'styled-components/macro';
export const GlobalStyle = createGlobalStyle`
    html, body, #root{
        display:flex;
        margin:0;
        padding:0;
        width:100%;
        background-color: ${(props) => props.theme.colors.primary.backgroundColor};
        font-family:${(props) => props.theme.fonts.primary.family};
        font-size:${(props) => props.theme.fonts.primary.size};
        color: ${(props) => props.theme.colors.primary.color};
    }
    a{
        color:${(props) => props.theme.colors.primary.color};
        text-decoration:none;
        &:hover{
            text-decoration:underline;
        }
    }
`;
